export const DB_NAME = "lodewallet";
